import React, { useState, useEffect, useRef } from "react";
import { getFirstRemainingUserEducationKey } from "utils/mapStateToProps";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useSelector } from "react-redux";
import Modal from "components/Modal";
import ModalContent from "components/ModalContent";
import ModalActions from "components/ModalActions";
import Analytics, { USER_EDUCATION } from "utils/analytics";
import {
  getEducationConfigForKey,
  getEducationSlidesForKey
} from "constants/education";
import { dismissEducationPayload } from "utils/education";
import { updateUserEducation } from "actions/user";
import { focusRef } from "utils/form";

const UserEducationModal = ({ keys, actions, innerRef }) => {
  const modalRef = useRef();
  const { remainingEducation, education, userId } = useSelector((state) => ({
    education: state.getIn(["user", "data", "education"]).toJS(),
    userId: state.getIn(["user", "data", "id"]),
    remainingEducation: getFirstRemainingUserEducationKey(state, keys)
  }));

  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(Boolean(remainingEducation));
  /**
   * Transitions: show modal if remaining education has become present and the modal is not showing
   */
  useEffect(() => {
    if (remainingEducation && !showModal) {
      setShowModal(true);
    }
  }, [remainingEducation]);
  const modalProps = {
    ref: modalRef,
    showModal,
    showCloseIcon: false,
    onClose: () => setShowModal(false)
  };

  return showModal ? (
    <Modal {...modalProps}>
      <ModalContent slides={getEducationSlidesForKey(remainingEducation)}>
        <ModalActions
          actions={[
            {
              cta: "Got it",
              loading: loading,
              onClick: () => {
                setLoading(true);
                Analytics.track(USER_EDUCATION, {
                  uid: keys[0]
                });
                const config = getEducationConfigForKey(remainingEducation);
                const payload = dismissEducationPayload(education, config);

                actions.updateUserEducation(userId, payload, () => {
                  innerRef && focusRef(innerRef);

                  setLoading(false);
                  setShowModal(false);
                });
              }
            }
          ]}
        />
      </ModalContent>
    </Modal>
  ) : null;
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      updateUserEducation
    },
    dispatch
  )
});

export default connect(null, mapDispatchToProps)(UserEducationModal);
